import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { notification } from "antd";
import { Can } from "@/shared/lib/casl";
import { useCoordinator } from "@/shared/lib/hooks";
import { queryClient } from "@/shared/lib/react-query";
import { objectQueries } from "@entities/object";
import { SettingsCardBlock } from "@features/settings-card-block";


export const ObjectSettings = () => {
  const { projectId } = useCoordinator();

  const { data, isLoading, error } = useQuery(
    objectQueries.getObjectSettings({ projectId }),
  );

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: objectQueries.getObjectSettings({ projectId }).queryKey,
    });
  }, [projectId]);

  if (error) {
    notification.error({
      message: "Не можем отобразить настройки обьекта",
      description: ``,
      placement: "topRight",
      showProgress: false,
    });
  }

  return (
    <>
      <Can I="edit" a="object">
      <SettingsCardBlock
        blockTitle="Дополнения "
        settingsList={data?.settings}
        isLoading={isLoading}
      />
      </Can>
    </>
  );
};
